import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { Map as LeaMap, TileLayer, Marker } from 'react-leaflet';

import races from '../../config/races';

import './map.less';

const defaultMapState = {
  coordinates: [40.4167, -3.703],
  zoom: 6,
};

const Map = ({ ref }) => {
  const [mapState, setMapState] = useState(defaultMapState);
  const handleOnClickMarker = event => {
    setMapState({
      coordinates: [event.latlng.lat, event.latlng.lng],
      zoom: 12,
    });
  };

  return (
    <section className="cdo-section cdo-section-map" ref={el => (ref = el)}>
      <h2>MAPA</h2>
      <div className="sectionMap--mapContainer">
        <LeaMap center={mapState.coordinates} zoom={mapState.zoom}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          {races.map(race => (
            <Marker
              key={race.id}
              position={race.coordinates}
              title={race.title}
              onClick={handleOnClickMarker}
            />
          ))}
        </LeaMap>
      </div>
    </section>
  );
};

export default withRouter(Map);
